export default function fancyBox(){
    if(document.querySelector("[data-fancybox='gallery-image']")){
        Fancybox.bind("[data-fancybox='gallery-image']", {
            Thumbs: {
                type: "classic",
            },
        });
    }

    if(document.querySelector("[data-fancybox='video']")){
        Fancybox.bind("[data-fancybox='video']", {
            Thumbs: {
                type: "classic",
            },
        });
    }
}
